/**
 * SA-1204 (spec §5): the ONE display rule for the request-to-first-quote clock,
 * shared by the strip and the queue cell. It matches the server's `waiting_longest`:
 * before a quote is sent only an open record (no outcome, not cancelled) shows the
 * waiting words; once one is sent the record shows the sent words whatever its state;
 * a closed or cancelled record with no quote shows nothing.
 */
import type { FirstQuote } from '@/types/commerce'

export type FirstQuoteState = {
  kind: 'waiting' | 'sent'
  minutes: number
  /** On the UNROUNDED figure: `minutes > targetMinutes`; equal is inside. */
  over: boolean
  targetMinutes: number
}

const MS_PER_MINUTE = 60_000

export function firstQuoteState(
  fq: FirstQuote | null | undefined,
  order: { outcome?: string | null; status: string },
  now: Date,
): FirstQuoteState | null {
  if (!fq) return null
  if (fq.sentAt !== null && fq.minutes !== null) {
    return { kind: 'sent', minutes: fq.minutes, over: fq.minutes > fq.targetMinutes, targetMinutes: fq.targetMinutes }
  }
  const open = !order.outcome && order.status !== 'cancelled'
  if (!open) return null
  const minutes = Math.max(0, (now.getTime() - new Date(fq.receivedAt).getTime()) / MS_PER_MINUTE)
  return { kind: 'waiting', minutes, over: minutes > fq.targetMinutes, targetMinutes: fq.targetMinutes }
}
